import { i18nMark } from 'lingui-react';

export default {
  CEVA_TRAILER: i18nMark('Ceva Trailer'),
  DART_TRAILER: i18nMark('Dart Trailer'),
  DART_TRANSIT_CO: i18nMark('DART Transit Co'),
  DOLLAR_GENERAL_TRAILER: i18nMark('Dollar General Trailer'),
  DRT_LOGISTICS: i18nMark('DRT Logistics'),
  EXTRA_LEASE_TRAILER: i18nMark(
    'Extra Lease Trailer (most start with a U or W)',
  ),
  FAMILY_DOLLAR: i18nMark('Family Dollar'),
  FEMA_EMERGENCY_FREIGHT: i18nMark('FEMA Emergency Freight'),
  KROGER_TRAILER: i18nMark('Kroger Trailer'),
  LOCKHEED_MARTIN: i18nMark('Lockheed Martin'),
  MISCELLANEOUS_TRAILER: i18nMark('Miscellaneous Trailer'),
  SWIFT_TRAILER: i18nMark('Swift Trailer'),
  TARGET_TRAILER: i18nMark('Target Trailer'),
  TOTAL_TRAILER: i18nMark('Total Trailer'),
  USX_TRAILER: i18nMark('USX Trailer'),
  // TODO: remove this misspelled key in favor of the correct one that follows
  VIRIGINIA_HIGHWAY_TRAILERS: i18nMark('Virginia Highway Trailers'),
  VIRGINIA_HIGHWAY_TRAILERS: i18nMark('Virginia Highway Trailers'),
  WALMART_REEFER_TRAILER: i18nMark('Walmart Reefer Trailer'),
  WHIRLPOOL_TRAILER: i18nMark('Whirlpool Trailer'),
};



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/RequestAssetsForm/RequestAsset/trailerTypeNames.js